export type ActiveDeviceStatus = SmartMeterActiveDeviceStatus | TenoviGatewayInfo;

export interface SmartMeterActiveDeviceStatus {
  text: string;
  status: string;
  details: any;
}

export interface UnmapDeviceRequest {
  message: string;
  status: number;
}

export interface TenoviGatewayInfo {
  gateway_uuid: string;
  firmware_version: string;
  bootloader_version: string;
  provisioned: boolean;
  text?: string;
  last_signal_strength: number;
  last_checkin_time: string;
  last_signal_strength_legend?: string;
  assigned_on: string;
  shipped_on: string;
  whitelisted_devices: [
    {
      sensor_code: string;
      mac_address: string;
      whitelist_status: string;
      created: string;
      modified: string;
    }
  ];
  properties: [
    {
      id: string;
      key: string;
      value: string;
    }
  ];
}

export interface DeviceStatus {
  deviceStatus: string;
  suspendDate: Date | null;
  daysToActivate: string;
  last_checkin_time?: string;
  last_signal_strength?: number;
  last_signal_strength_legend?: string;
  signal_icon?: string;
  signal_color?: string;
}

export interface DeviceUserMapping {
  auto_refill?: boolean;
  client_id?: string;
  device_id?: string;
  device_mfg?: string;
  device_ref_id?: string;
  user_id?: string;
  lastUpdate?: any;
  source?: string;
}

// Type guard function to check if the device status is SmartMeterActiveDeviceStatus
export const isSmartMeterStatus = (deviceStatus: ActiveDeviceStatus): deviceStatus is SmartMeterActiveDeviceStatus =>
  'details' in deviceStatus;

// Type guard function to check if the device status is TenoviGatewayInfo
export const isTenoviGateway = (deviceStatus: ActiveDeviceStatus): deviceStatus is TenoviGatewayInfo =>
  'gateway_uuid' in deviceStatus;
